




























































































































import { Component, Prop, Vue, Watch, Ref } from "vue-property-decorator";
import PersonSelect from "./PersonSelect.vue";
import StepHead from "../Stepper/StepHead.vue";
import PersonDocument from "../FormParts/PersonForm/PersonDocument.vue";
import PersonNameBD from "../FormParts/PersonForm/PersonNameBD.vue";
import { DefaultCopy } from "_P/copyobj";
import { Person, InsuranceCard, Document } from "@/services/index.defs";
import { ValidationRules } from "_P/validate";
import { GaHelper } from "@/core/helpers/ga";
@Component({
    components: { StepHead, PersonSelect, PersonDocument, PersonNameBD },
})
export default class Step1 extends Vue {
    Rules = ValidationRules;
    state = 1;

    isCreated: boolean = false;
    insurerIsOwner: boolean = this.card.insurerIsOwner;
    @Watch("insurerIsOwner")
    insurerIsOwnerChanged(val) {
        if (val) this.card.owner = DefaultCopy(this.card.insurer);
        else this.card.owner = new Person();
    }
    mounted() {
        GaHelper.send("insurer");
    }

    created() {
        if (!this.card.insurer.passport) {
            this.card.insurer.passport = new Document();
        }
    }

    get isFastCalcDisabled() {
        return this.$store.direct.getters.isFastCalcDisabled;
    }

    goBack() {
        if (this.isFastCalcDisabled) {
            this.$router.push({ name: 'precheck', params: { step: '3' } });
        }

        this.state = 1;
    }

    get card(): InsuranceCard {
        return this.$store.direct.state.insurance.card;
    }
    setInsurer(person: Person) {
        this.state = 2;
        this.card.insurer = person ?? new Person();
    }
    async clearInsurer() {
        this.card.insurer = new Person();

        await this.$nextTick();
        this.card.insurer.birthDate = new Date();
        this.card.insurer.passport.docDate = new Date();
        await this.$nextTick();
        this.card.insurer.birthDate = null;
        this.card.insurer.passport.docDate = null;
    }
    async clearOwner() {
        this.card.owner = new Person();

        await this.$nextTick();
        this.card.owner.birthDate = new Date();
        this.card.owner.passport.docDate = new Date();
        await this.$nextTick();
        this.card.owner.birthDate = null;
        this.card.owner.passport.docDate = null;

    }

    @Ref("form") form: { validate: Function };
    async nextStep() {
        let isValid = this.form.validate();
        if (!isValid) return;

        if (this.insurerIsOwner)
            this.card.owner = DefaultCopy(this.card.insurer);
        this.$emit("next");
    }
}
